import api from "../axios_service.js";

export async function fetchClienteServicos(id) {
  const response = await api.get(`/colaborador/clientes-servicos/${id}`);
  return response.data.result;
}
